import { type ReactElement } from 'react';
import { type PumpStationProperties } from '../Sources/PumpStationSource';
import PopupTemplateWrapper from './PopupTemplateWrapper';

export default function PumpStation(properties: PumpStationProperties): ReactElement {
    return (
        <PopupTemplateWrapper iconId="bike-pump-marker" title="Cykelpump">
            <div className="">
                <h3>{properties.address}</h3>
            </div>
        </PopupTemplateWrapper>
    );
}
